export function formatExecutionError(err, fallback = "Execution failed.") {
    const payload = err?.response?.data || {};
    const safetyCode = String(payload?.safety_code || "").toLowerCase();
    const statusCode = Number(err?.response?.status || 0);
    const errorCode = String(err?.code || "").toUpperCase();
    const reason =
        payload?.message
        || payload?.error
        || (typeof payload?.details === "string" ? payload.details : null)
        || err?.message
        || fallback;

    if (errorCode === "ECONNABORTED" || /timeout/i.test(String(reason || ""))) {
        return "Trade submission took too long. Check Positions or Trade Orders before retrying so you do not submit a duplicate trade.";
    }
    if (!err?.response && reason) {
        return `Trade submission did not complete cleanly. ${reason}`;
    }

    if (safetyCode === "duplicate_open_position" || /open position already exists/i.test(reason)) {
        return "This trade was blocked because you already have an open position for this symbol.";
    }
    if (safetyCode === "duplicate_queued_order" || /queued order already exists/i.test(reason)) {
        return "This trade was blocked because you already have a queued trade for this symbol.";
    }
    if (safetyCode === "max_concurrent_positions") {
        return "This trade was blocked because your account already has the maximum number of concurrent positions or queued trades.";
    }
    if (statusCode === 409) {
        return reason || "This trade conflicts with current account state.";
    }
    return String(reason || fallback);
}
